<div class="policy_scrn">
  <div class="d-sm-flex align-items-center justify-content-between mb-4">
    <a href="#" class="d-sm-inline-block create_quote">
      Create Quote
      <i class="fa fa-angle-right ml-2 btn_arrow"></i>
    </a>
  </div>
  <!-- Page Heading -->
  <div class="d-sm-flex align-items-center justify-content-between mb-4">
    <h1 class="h3 mb-0 ml-4 text_black_cls"><span class="text-gray-800">
        <b>Policy</b></span> {{dao?.policyNumber ? dao?.policyNumber : '-'}}</h1>
    <a  (click)="clickCancelPolicy();" class=" d-sm-inline-block cancel_policy mr-4" >
      Cancel Policy
    </a>
  </div>

  <!-- Content Row -->
  <div class="row">
    <div class="col-xl-12">

      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#tabs-1" role="tab" (click)="ActiveTab = 'client-data';">Client Data</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#tabs-2" role="tab" (click)="ActiveTab = 'policy-details';">Policy Details</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#tabs-3" role="tab" (click)="ActiveTab = 'claims';">Claims</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#tabs-4" role="tab" (click)="ActiveTab = 'evidence-of-insurance';">Evidence of Insurance</a>
        </li>
      </ul><!-- Tab panes -->

      <div class="tab-content pt-3 pb-3 pl-1 pr-1">
        <div class="tab-pane active" id="tabs-1" role="tabpanel" *ngIf="ActiveTab == 'client-data'">
          <app-client-data [clientData]="dao?.clientInfo"></app-client-data>
        </div>
        <div class="tab-pane" id="tabs-2" role="tabpanel" *ngIf="ActiveTab == 'policy-details'">
          <app-policy-details></app-policy-details>
        </div>
        <div class="tab-pane" id="tabs-3" role="tabpanel" *ngIf="ActiveTab == 'claims'">
          <app-claims></app-claims>
        </div>
        <div class="tab-pane" id="tabs-4" role="tabpanel" *ngIf="ActiveTab == 'evidence-of-insurance'">
          <app-evidence-of-insurance></app-evidence-of-insurance>
        </div>
      </div>
    </div>
  </div>
  <app-cancel-policy-popup [cancelDetails]="cancelDetails" (pushCancelDetails)="pushCancelDetails()" [IsCancel]="IsCancel" *ngIf="IsCancelPopup"></app-cancel-policy-popup>
</div>